var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing-page"}},[_c('landing-menu'),_vm._v(" "),_c('div',{staticClass:"wrap"},[_c('router-view')],1),_vm._v(" "),(_vm.$route.name === 'bizIntro')?_c('biz-footer'):_c('landing-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e2b6e5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/officailPage/landingPage.vue
// module id = null
// module chunks = 